import { HttpErrorResponse } from '@angular/common/http';
import { BusinessProfile, UserAccount } from '@iot-platform/models/common';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Privileges } from '../../authorization.types';
import { AuthSession } from '../../models/auth-session.model';

type ApiError = HttpErrorResponse | Error;

export const AuthApiActions = createActionGroup({
  source: '[Auth] API Actions',
  events: {
    signInSuccess: props<{ session: AuthSession }>(),
    signInFailure: props<{ error: ApiError }>(),
    signInWithSSOSuccess: props<{ idToken: string; accessToken: string; refreshToken: string; expiresIn: number }>(),
    signInWithSSOFailure: props<{ error: HttpErrorResponse }>(),
    loadAccountSuccess: props<{ account: UserAccount; withRedirect?: boolean }>(),
    loadAccountFailure: props<{ error: ApiError }>(),
    loadPrivilegesSuccess: props<{ privileges: Privileges }>(),
    loadPrivilegesFailure: props<{ error: ApiError }>(),
    signOutSuccess: emptyProps(),
    signOutFailure: props<{ error: ApiError }>(),
    changePasswordSuccess: props<{ result: unknown }>(),
    changePasswordFailure: props<{ error: ApiError }>(),
    forgotPasswordSuccess: props<{ result: unknown }>(),
    forgotPasswordFailure: props<{ error: ApiError }>(),
    updatePasswordWithCodeSuccess: props<{ result: unknown }>(),
    updatePasswordWithCodeFailure: props<{ error: ApiError }>(),
    retrieveSsoSessionSuccess: props<{ idToken: string; accessToken: string; refreshToken: string }>(),
    retrieveSsoSessionFailure: props<{ error: ApiError }>(),
    refreshSsoTokensSuccess: props<{ idToken: string; accessToken: string; tokenType: string; expiresIn: number }>(),
    refreshSsoTokensFailure: props<{ error: ApiError }>(),
    retrieveSession: emptyProps(),
    retrieveSessionSuccess: props<{ session: AuthSession }>(),
    retrieveSessionFailure: props<{ error: ApiError }>(),
    refreshToken: emptyProps(),
    refreshTokenSuccess: props<{ session: AuthSession }>(),
    refreshTokenFailure: props<{ error: ApiError }>(),
    checkIfUserIsAdmin: props<{ entityId: string; userId: string }>(),
    checkIfUserIsAdminSuccess: props<{ isAdminUser: boolean }>(),
    checkIfUserIsAdminFailure: props<{ error: ApiError }>(),
    setBusinessProfiles: props<{ businessProfiles: BusinessProfile[] }>()
  }
});
